<template>
  <v-dialog
    :value="isAtivarOuInativarAssociacaoDialogOpen"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title class="headline text-capitalize">
        {{ isAssociacaoAtivaMensagem }}
      </v-card-title>

      <v-card-text>
        {{ `Tem certeza que vai ${isAssociacaoAtivaMensagem} a associação?` }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="error"
          outlined
          @click="closeDialog"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="success"
          @click="confirmarAtivacaoOuInativacaoDaAssociacao"
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="secundary"
          />
          <span v-else>OK</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isAtivarOuInativarAssociacaoDialogOpen: {
      type: Boolean,
      required: true,
    },
    isAssociacaoAtivaMensagem: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
    confirmarAtivacaoOuInativacaoDaAssociacao: {
      type: Function,
      required: true,
    },
  },
}
</script>
